import { ENGAJAMENTO_LABEL, ENGAJAMENTO_MAX, type PassoEngajamento } from "../types";

/** Leitura compacta da escada de engajamento: 10 barrinhas que enchem até o passo. */
export function EngajamentoMini({ passo }: { passo: PassoEngajamento | null }) {
  const v = passo ?? -1;
  const rotulo = passo === null ? "sem momentos ainda" : ENGAJAMENTO_LABEL[passo];
  return (
    <div className="escada-mini" role="img" aria-label={`engajamento: ${rotulo}`}>
      {Array.from({ length: ENGAJAMENTO_MAX + 1 }, (_, i) => (
        <i
          key={i}
          className={i <= v ? "on" : ""}
          style={{ height: `${30 + (i / ENGAJAMENTO_MAX) * 70}%` }}
        />
      ))}
    </div>
  );
}
